{
  "name": "@gemini-wallet/core",
  "version": "0.3.2",
  "description": "Core SDK for Gemini Wallet integration with popup communication",
  "main": "./dist/index.cjs",
  "types": "./dist/index.d.ts",
  "type": "module",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/gemini/gemini-wallet-core.git"
  },
  "homepage": "https://keys.gemini.com",
  "bugs": {
    "url": "https://github.com/gemini/gemini-wallet-core/issues"
  },
  "license": "MIT",
  "author": "Gemini",
  "files": [
    "dist",
    "src",
    "README.md",
    "LICENSE"
  ],
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js",
      "require": "./dist/index.cjs"
    },
    "./package.json": "./package.json"
  },
  "scripts": {
    "build": "dotenv -e .env.production -- tsup",
    "dev": "dotenv -e .env.local -- tsup --watch",
    "typecheck": "tsc --noEmit",
    "lint": "eslint ./src",
    "lint:ci": "eslint --max-warnings 0 ./src",
    "lint:fix": "eslint ./src --fix",
    "test": "bun test"
  },
  "dependencies": {
    "@metamask/rpc-errors": "7.0.2",
    "eventemitter3": "5.0.1"
  },
  "devDependencies": {
    "@eslint/eslintrc": "3.3.1",
    "@eslint/js": "9.38.0",
    "@types/node": "22.13.0",
    "dotenv-cli": "10.0.0",
    "esbuild-plugin-replace": "1.4.0",
    "eslint": "9.38.0",
    "eslint-config-prettier": "10.1.8",
    "eslint-config-turbo": "2.5.6",
    "eslint-plugin-import": "2.32.0",
    "eslint-plugin-only-warn": "1.1.0",
    "eslint-plugin-prettier": "5.5.4",
    "eslint-plugin-simple-import-sort": "12.1.1",
    "eslint-plugin-sort-keys-fix": "1.1.2",
    "globals": "16.4.0",
    "prettier": "3.6.2",
    "tsup": "8.5.0",
    "typescript": "5.5.3",
    "typescript-eslint": "8.40.0",
    "vitest": "3.2.4"
  },
  "peerDependencies": {
    "viem": ">=2.0.0"
  },
  "keywords": [
    "gemini",
    "wallet",
    "sdk",
    "ethereum",
    "web3",
    "crypto"
  ],
  "module": "./dist/index.js"
}